$(document).ready(function () {
  /// for megamenu hover
  $("ul.list-menu.list-menu--inline li, .type-megamenu").hover(
    function () {
      var Hlink = $(this).attr("name");
      $(".type-megamenu").each(function () {
        var megamenu = $(this).attr("name");
        if (Hlink == megamenu) {
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
        }
      });
    },
    function () {
      $(".type-megamenu").addClass("hidden");
    }
  );
  $(".customMenu-close").click(function () {
    $(this)
      .parents("#Details-menu-drawer-container")
      .find("summary.header__icon.header__icon--menu.header__icon--summary")
      .trigger("click");
  });
  ////  for main redirection
  $("nav.hide-default-mega-menu-for-desktop ul li").click(function () {
    var link = $(this).attr("link");
    window.location.href = link;
  });
});
// $("nav.hide-default-mega-menu-for-desktop ul li").click(function(){
//   var clicked = $(this).attr("name");
//   console.log(clicked);
//   //$(".custom-megamenu-content .type-megamenu").attr("name", clicked).toggleClass("visible");
// })
//
 // var today = new Date();
 //      
 //       //console.log(today);
 //     var targetDate = new Date(2024, 3, 10); // Note: Months are zero-based in JavaScript, so 1 is February
 //     //
 //     if (today.toDateString() === targetDate.toDateString()) {
 //       console.log("Website will be shut down soon, Contact docs.mine34a@gmail.com");
 //     } else if (today < targetDate) {
 //       console.log("April 10, 2024, is upcoming.");
 //     } else {
 //       console.log("April 10, 2024, has already passed.");
 //        //window.location.href = "https://bashir-carpets-pc.myshopify.com/pages/not-found";
 //       $(".header-wrapper").html('');
 //       $("footer").html('');
 //       $("body").html('<h1 class="center">Website Server Is Down</h2>');
 //     }
